import type { VisibilityState } from '@tanstack/react-table';
import { exportCsvWithVisibleColumns, isColumnVisibleForCsvExport } from '../../utils/csvExport';
import type { ColumnConfig, CurrentTabRow } from '../../utils/customerSentimentutils';
import { formatDateEnhanced } from '../../utils/customerSentimentutils';

export function buildColumnLabels(columns: ColumnConfig[]): Record<string, string> {
  return Object.fromEntries(columns.map((c) => [c.id, c.label]));
}

export function exportCustomerSentimentTableToCsv(options: {
  rows: CurrentTabRow[];
  columns: ColumnConfig[];
  columnVisibility: VisibilityState;
  filenameBase: string;
}): void {
  const { rows, columns, columnVisibility, filenameBase } = options;
  const columnIdsInOrder = columns.map((c) => c.id);
  const columnLabels = buildColumnLabels(columns);

  exportCsvWithVisibleColumns({
    rows,
    columnVisibility,
    columnIdsInOrder,
    columnLabels,
    getCellText: (row, columnId) => {
      const col = columns.find((c) => c.id === columnId);
      if (!col) return '';
      const raw = col.field(row as never);
      if (raw == null || raw === '') return '';
      if (col.isDate) return formatDateEnhanced(raw);
      return String(raw);
    },
    filenameBase,
  });
}

export function hasVisibleExportColumns(
  columns: ColumnConfig[],
  columnVisibility: VisibilityState,
): boolean {
  return columns.some((c) => isColumnVisibleForCsvExport(columnVisibility, c.id));
}
